import { IComponentOptions } from "angular";
import { ConversionModalComponentController } from "./controller";

export const conversionModalComponentOptions: IComponentOptions = {
  controller: ConversionModalComponentController,
  controllerAs: "conversionModalComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    modalInstance: "=",
    resolve: "=",
  },
};
